export type ProjectGallerySlug =
  | 'construction'
  | 'kitchens'
  | 'bathrooms'
  | 'full-home'
  | 'extensions'
  | 'outdoors'
  | 'roofing';

export type LegacyGalleryFolder =
  | 'kitchens'
  | 'bathrooms'
  | 'full home'
  | 'extensions'
  | 'outdoors'
  | 'roofing';

export const FOLDER_MAP: Record<Exclude<ProjectGallerySlug, 'construction'>, LegacyGalleryFolder> = {
  kitchens: 'kitchens',
  bathrooms: 'bathrooms',
  'full-home': 'full home',
  extensions: 'extensions',
  outdoors: 'outdoors',
  roofing: 'roofing',
};

export const PROJECT_TAB_LABELS: Record<ProjectGallerySlug, string> = {
  construction: 'Construction',
  kitchens: 'Kitchens',
  bathrooms: 'Bathrooms',
  'full-home': 'Full property',
  extensions: 'Extensions',
  outdoors: 'External works',
  roofing: 'Roofing',
};

export interface ProjectMeta {
  title: string;
  sector: string;
  location: string;
  scope: string;
}

export const PROJECT_META: Record<ProjectGallerySlug, ProjectMeta> = {
  construction: {
    title: 'Construction & site works',
    sector: 'Commercial / residential',
    location: 'Glasgow & central Scotland',
    scope: 'New build, structural, shell & core, fit-out',
  },
  kitchens: {
    title: 'Kitchen construction',
    sector: 'Residential',
    location: 'Glasgow',
    scope: 'Full kitchen builds — design through installation',
  },
  bathrooms: {
    title: 'Bathroom construction',
    sector: 'Residential',
    location: 'Glasgow',
    scope: 'Full bathroom builds — plumbing, tiling, finishes',
  },
  'full-home': {
    title: 'Full property works',
    sector: 'Residential',
    location: 'Glasgow',
    scope: 'Whole-house construction and interior delivery',
  },
  extensions: {
    title: 'Extensions',
    sector: 'Residential',
    location: 'Glasgow',
    scope: 'Ground-floor and multi-storey extensions',
  },
  outdoors: {
    title: 'External works',
    sector: 'Residential',
    location: 'Glasgow',
    scope: 'Landscaping, driveways, and external structures',
  },
  roofing: {
    title: 'Roofing',
    sector: 'Residential / commercial',
    location: 'Glasgow & central Scotland',
    scope: 'Roof replacement, repair, and envelope works',
  },
};
